import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Alert, Button, Modal} from "antd"

class ChangeNameUserCreateModal extends Component {
    _handleChangeNameUser = e => {
        const {onChangeName} = this.props
        const name = e.target.value

        if (typeof onChangeName === 'function') {
            onChangeName(name)
        }
    }

    render() {
        const {isOpen, onClose, userCreate, loading, error, isUpdated, onUpdateName, errorUpdate} = this.props

        return (
            <div className='ChangePartnerModal'>
                <Modal
                    title="Thay đổi tên người tạo lô"
                    visible={isOpen}
                    onCancel={onClose}
                    footer={[
                        <div key='select' className='d-flex justify-content-between align-items-center'>
                            <Button key="back" onClick={onClose}>
                                Hủy
                            </Button>
                            <Button key="submit" type="primary" disabled={!isUpdated} loading={loading}
                                    onClick={onUpdateName}>
                                Thay đổi
                            </Button>
                        </div>
                    ]}
                >
                    <div>
                        <input className='form-control' value={userCreate}
                               onChange={this._handleChangeNameUser}/>

                        {error && <Alert message={error} type='error' className='mt-3'/>}
                        {errorUpdate && <Alert message={errorUpdate} type='error' className='mt-3'/>}
                    </div>
                </Modal>
            </div>
        )
    }
}

ChangeNameUserCreateModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    userCreate: PropTypes.string,
    loading: PropTypes.bool,
    error: PropTypes.string,
    isUpdated: PropTypes.bool,
    onUpdateName: PropTypes.func.isRequired,
    errorUpdate: PropTypes.string
}

export default ChangeNameUserCreateModal
